import { NodeData } from "./NodeData";

export class Node {
    /** General purpose data member that can hold data for application specific use */
    data;

    constructor() {}

    /** factory function
     * @param {NodeData} data
     * @return {Node} instance
     */
    static build(data) {
        let instance = new Node();
        instance.data = data;
        return instance;
    }

    getData() {
        return this.data;
    }

    toJSON() {
        return {
            data: this.data
        };
    }

    static jsonDeserialize(jsonString) {
        let data = jsonString.data;
        return Node.build(NodeData.jsonDeserialize(data));
    }

}